import Swiper from 'swiper/bundle';
var swiperLookBook24 = new Swiper('.pl24-swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  mousewheel: true,
  breakpoints: {
    320: {
      navigation: {
        nextEl: '.pl24-anchor_arrow'
      },
      centeredSlides: true
    },
    768: {
      navigation: {
        nextEl: '.pl24-swiper_arrow'
      },
      spaceBetween: 0,
      centeredSlides: false
    }
  }
});
var searchingIndexCarouselLookbook = function searchingIndexCarouselLookbook(swiper) {
  var carouselPageContainer = document.querySelector('.pl24-main_container .swiper-container');
  var url = window.location.href;
  var hasParams = url.indexOf('?');
  var searchParams = new URLSearchParams(window.location.search);
  var fragment = searchParams.get('ID');
  var carouselItem = document.getElementById(fragment);
  if (searchParams.size > 0 || hasParams !== -1) {
    if (carouselItem) {
      var itemIndex = carouselItem.ariaLabel.split(' ')[0];
      setTimeout(function () {
        swiper.slideTo(itemIndex - 1);
      }, 100);
      swiper.on('slideChangeTransitionEnd', function () {
        carouselPageContainer.style.opacity = 1;
      });
    }
  } else {
    carouselPageContainer.style.opacity = 1;
  }
};
export var initLookBook24 = function initLookBook24() {
  if (document.querySelector('.pl24-main_container')) {
    searchingIndexCarouselLookbook(swiperLookBook24);
  }
};